module.exports = __webpack_public_path__ + "img/deviceBigScreen.d86aa65f.jpg";